module.exports = __webpack_public_path__ + "media/newstyle/images/icon-book-grey-cf645d11aaa3654a98745455795dd290.svg";